import React, { useState } from 'react';
import './AboutHero.scss';
import Owl from '../../UI/Graphics/Owl';
import { Waypoint } from 'react-waypoint';
import { COLORS } from '../../../constants/colors';

/**
 * Renders the About page hero component
 * @param {string} backgroundImage
 * @param {string} title
 * @param {object} imageOne
 * @param {string} body
 * @param {object} imageTwo
 * @returns {JSX.Element}
 * @constructor
 */
const AboutHero = ({ backgroundImage, title, imageOne, body, imageTwo }) => {
  const [isGradient, setIsGradient] = useState(false);

  return (
    <div className="c-about-hero background-color-white">
      <div className="c-about-hero__inner">
        <div className="c-about-hero__top">
          <div className="c-about-hero__title h4-right-grotesk">
            <h4>{title}</h4>
          </div>
          <div className="c-about-hero__top-image">
            <img src={imageOne.url} alt={imageOne.alt} />
          </div>
        </div>
        <Waypoint
          onEnter={() => setIsGradient(true)}
          onLeave={() => setIsGradient(false)}
          bottomOffset={'35%'}
          topOffset={'35%'}
        >
          <div className="c-about-hero__bottom">
            <div className="c-about-hero__body h4-roobert">
              <div className="c-about-hero__body--inner">
                <p>{body}</p>
              </div>
              <div className={`c-about-hero__owl ${isGradient ? 'is-gradient' : ''}`}>
                <Owl color={COLORS.black} />
                <Owl useGradient={true} />
              </div>
            </div>
            <div className="c-about-hero__bottom-image">
              <img src={imageTwo.url} alt={imageTwo.alt} />
            </div>
          </div>
        </Waypoint>
      </div>
      <style>{`
                .c-about-hero::before {
                    background: url(${backgroundImage}) no-repeat top/cover;
                }
            `}</style>
    </div>
  );
};

export default AboutHero;
